import api from "../services/API";

export const AuthService = {
  login: async (Email, Password) => {
    console.log("ID Pass Before Sending:" + Email + Password);
    const response = await api.post("/auth/login", {
      Email,
      Password,
    });
    const data = response.data;
    if (data.user.Job_Title == "Admin") {
      if (response.status === 200 && data.token) {
        // Store the token in localStorage after successful login
        localStorage.setItem("token", data.token);
        return data;
      }
    } else {
      throw new Error(data.message || "Access Denied: Admins Only");
    }

    throw new Error(data.message || "Login failed");
  },

  logout: () => {
    // Remove the token from localStorage on logout
    localStorage.removeItem("token");
  },

  isLoggedIn: () => {
    // Check if the token exists in localStorage
    return !!localStorage.getItem("token");
  },
};
